var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"containerRef"},[_c('transition',{attrs:{"mode":"out-in","duration":_vm.duration},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }